import { tv } from "tailwind-variants";

export const CpBadgeVariants = tv({
  base: "flex items-center gap-1 text-xs font-semibold cursor-default box-border w-fit outline-none select-none min-w-0 rounded-lg px-2",
  variants: {
    button: {
      true: [
        "relative cursor-pointer select-none focus-visible:shadow-cp-form-focus-state",
        "after:content-[''] after:absolute after:inset-0 after:bg-black after:opacity-0 after:transition-opacity after:duration-[var(--cp-form-transition-duration)] after:ease-in-out after:rounded-[var(--cp-form-border-radius)]",
        "after:hover:opacity-[8%]",
        "after:active:hover:opacity-[13%]",
      ],
    },
    size: {
      sm: "h-5 rounded-md px-1.5 gap-0.5",
      md: "h-6",
    },
    iconOnly: {
      true: "px-1",
    },
    intent: {
      base: "bg-[var(--cp-color-badge-bg-base)] text-[var(--cp-color-badge-text-base)] border border-[var(--cp-color-badge-border-base)]",
      success:
        "bg-[var(--cp-color-badge-bg-success)] text-[var(--cp-color-badge-text-success)] ",
      critical:
        "bg-[var(--cp-color-badge-bg-critical)] text-[var(--cp-color-badge-text-critical)] ",
      neutral:
        "bg-[var(--cp-color-badge-bg-neutral)] text-[var(--cp-color-badge-text-neutral)]",
      brand:
        "bg-[var(--cp-color-badge-bg-brand)] text-[var(--cp-color-badge-text-brand)]",
      "brand-alt":
        "bg-[var(--cp-color-badge-bg-brand-alt)] text-[var(--cp-color-badge-text-brand-alt)]",
      warning:
        "bg-[var(--cp-color-badge-bg-warning)] text-[var(--cp-color-badge-text-warning)]",
    },
    disabled: {
      true: "cursor-default opacity-50 after:hover:content-none",
    },
    active: {
      true: "!bg-[var(--cp-color-badge-bg-active)] !text-[var(--cp-color-badge-text-active)] !border-[var(--cp-color-badge-border-active)]",
    },
  },
});
